import { useState } from 'react';
import { getMouseWorld } from '../utils/canvasUtils';

// Хук для управления выделением прямоугольником
export const useBoxSelection = (canvasRef, zoom) => {
    const [isSelecting, setIsSelecting] = useState(false);
    const [selectionBox, setSelectionBox] = useState(null);

    const handleSelectionStart = (e) => {
        const { x, y } = getMouseWorld(e, canvasRef, zoom);
        setIsSelecting(true);
        setSelectionBox({ startX: x, startY: y, endX: x, endY: y });
    };

    const handleSelectionMove = (e) => {
        if (!isSelecting || !selectionBox) return;
        const { x, y } = getMouseWorld(e, canvasRef, zoom);
        setSelectionBox((prev) => ({
            ...prev,
            endX: x,
            endY: y
        }));
    };

    const handleSelectionEnd = (elements) => {
        if (!isSelecting || !selectionBox) return { selectedIds: new Set() };

        const minX = Math.min(selectionBox.startX, selectionBox.endX);
        const maxX = Math.max(selectionBox.startX, selectionBox.endX);
        const minY = Math.min(selectionBox.startY, selectionBox.endY);
        const maxY = Math.max(selectionBox.startY, selectionBox.endY);

        const ids = new Set();
        elements.forEach((el) => {
            // Processing arrows
            if (el.type === 'arrow') {
                if (
                    (el.x > minX && el.x < maxX && el.y > minY && el.y < maxY) ||
                    (el.x2 > minX && el.x2 < maxX && el.y2 > minY && el.y2 < maxY)
                ) {
                    ids.add(el.id);
                }
                return;
            }

            // Processing text (approximate by point if width/height missing, or bbox if present)
            if (el.type === 'text') {
                 // Try to guess bbox around text roughly for better selection
                 // But for now, existing logic checks point.
                 // If we have width/height (which we might not for text unless measured), use point
                 if (el.x > minX && el.x < maxX && el.y > minY && el.y < maxY) {
                     ids.add(el.id);
                 }
                 return;
            }

            // Processing circle-based shapes (Circle, Interface)
            // They have x, y (top-left usually or center? standard is top-left for rect, but let's check definition)
            // In elements.js: circle x,y are top-left bounding box logic in render?
            // In ElementRenderer:
            //   case ELEMENT_TYPES.CIRCLE:
            //   case ELEMENT_TYPES.INTERFACE:
            //       cx = element.x + element.radius;
            //       cy = element.y + element.radius;
            // So x,y is top-left of the bounding box of the circle.
            if (el.radius) {
                // Check if bounding box of circle overlaps selection
                if (
                    el.x < maxX &&
                    el.x + el.radius * 2 > minX &&
                    el.y < maxY &&
                    el.y + el.radius * 2 > minY
                ) {
                    ids.add(el.id);
                }
                return;
            }

            // Processing rectangular shapes (everything else having width/height)
            if (el.width && el.height) {
                if (
                    el.x < maxX &&
                    el.x + el.width > minX &&
                    el.y < maxY &&
                    el.y + el.height > minY
                ) {
                    ids.add(el.id);
                }
            }
        });

        setIsSelecting(false);
        setSelectionBox(null);

        return { selectedIds: ids };
    };

    return {
        isSelecting,
        selectionBox,
        handleSelectionStart,
        handleSelectionMove,
        handleSelectionEnd
    };
};
